import api from "../api"
import auth from "./auth"

const { getTokenFromLocalStorage } = auth()

function generateRequestHeaders(){
  const token = getTokenFromLocalStorage()
  return token === null ? {
    'X-Api-Key': api.key
  } : {
    'X-Api-Key': api.key,
    'Authorization': `JWT ${token}`
  }
}

export { generateRequestHeaders }
